import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2, Info } from "lucide-react";

export default function CheckIn() {
  const { lessonId, token } = useParams();
  const nav = useNavigate();
  const postedRef = useRef(false);
  const [state, setState] = useState({ loading: true, ok: null, already: false, msg: "" });

  useEffect(() => {
    if (postedRef.current) return;
    postedRef.current = true;
    api.post(`/student/portal/lessons/${lessonId}/checkin-qr`, { token })
      .then(() => setState({ loading: false, ok: true, already: false, msg: "Presença registrada com sucesso." }))
      .catch((err) => {
        const detail = err?.response?.data?.detail || "";
        const isAlready = err?.response?.status === 400 && /já foi registrada|já estava registrada|já registrada/i.test(detail);
        if (isAlready) setState({ loading: false, ok: true, already: true, msg: "Sua presença já estava registrada nesta aula." });
        else setState({ loading: false, ok: false, already: false, msg: formatApiError(err) });
      });
  }, [lessonId, token]);

  return <div className="min-h-screen bg-[#F8F3EA] flex items-center justify-center p-4"><div className="doxa-card p-8 max-w-md w-full text-center" data-testid="checkin-result">
    {state.loading && <><Loader2 className="w-12 h-12 mx-auto text-[#F75A1B] animate-spin" /><p className="mt-4 text-[#6B655E]">Registrando sua presença…</p></>}
    {!state.loading && state.ok && !state.already && <><CheckCircle2 className="w-14 h-14 mx-auto text-[#2F855A]" /><h1 className="font-display text-2xl font-bold mt-4">Presença confirmada!</h1><p className="text-[#6B655E] mt-2">{state.msg}</p></>}
    {!state.loading && state.ok && state.already && <><Info className="w-14 h-14 mx-auto text-[#2F855A]" /><h1 className="font-display text-2xl font-bold mt-4">Presença já registrada</h1><p className="text-[#6B655E] mt-2">{state.msg}</p></>}
    {!state.loading && state.ok === false && <><XCircle className="w-14 h-14 mx-auto text-[#C53030]" /><h1 className="font-display text-2xl font-bold mt-4">Não foi possível</h1><p className="text-[#6B655E] mt-2">{state.msg}</p></>}
    <button onClick={() => nav("/aluno?view=aulas")} className="doxa-btn-primary mt-6 px-5 py-2.5">Voltar às aulas</button>
  </div></div>;
}
